import { render, staticRenderFns } from "./QuickAccessSection.vue?vue&type=template&id=f0edfda8&scoped=true&lang=pug"
import script from "./QuickAccessSection.vue?vue&type=script&lang=js"
export * from "./QuickAccessSection.vue?vue&type=script&lang=js"
import style0 from "./QuickAccessSection.styl?vue&type=style&index=0&id=f0edfda8&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0edfda8",
  null
  
)

export default component.exports